"use client";

import JobCardSkeleton from "@/components/careers/JobCardSkeleton";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

const JOB_CARD_SKELETON_KEYS = [
  "job-card-skeleton-1",
  "job-card-skeleton-2",
  "job-card-skeleton-3",
];

export default function CareersOpenPositionsSkeleton() {
  const { t } = useTranslation();

  return (
    <div
      className={clsx(
        "grid gap-6",
        "grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3",
      )}
      aria-label={t("careers.loadingJobs")}
    >
      {JOB_CARD_SKELETON_KEYS.map((key) => (
        <JobCardSkeleton key={key} />
      ))}
    </div>
  );
}
